import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Form, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Cookie from 'js-cookie';
// icons
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
//api
import { backofficeLogin } from 'api/login';
import { getUserPermissions } from 'api/users';
//helpers
import { capitalize } from 'helpers';
//context
import { useGlobalContext } from 'context/globalContext';
import { UserContext } from 'context/userContext';
//slices
import {
  loginSuccess,
  setIsWorker,
  fetchUserInfo
} from 'slices/user';
//components
import { InputCustom } from 'components/input';
import ButtonCustom from 'components/backoffice/buttonCustom';
import HeadIntranet from 'components/metatags_helmet/metatagsIntranet';

const IntranetLogin = () => {
  const { t } = useTranslation(['login', 'backoffice']);
  const { setIsLoading } = useGlobalContext();
  const navigate = useNavigate();
  const [invalidCredentials, setInvalidCredentials] = useState(false);
  const [emailInput, setEmailInput] = useState('');
  const [password, setPassword] = useState('');
  const { setIsLogged } = useContext(UserContext);
  const dispatch = useDispatch();
  const [passwordType, setPasswordType] = useState('password');
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const handleName = (e) => {
    return setEmailInput(e);
  };
  const handlePassword = (e) => {
    return setPassword(e);
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (!form.checkValidity()) {
      setValidated(true);
      e.stopPropagation();
      return;
    }

    setInvalidCredentials(false);
    setLoading(true);
    const payload = { username: emailInput, password };
    const { status, data } = await backofficeLogin(payload);
    if (status === 200 || status === 201) {
      localStorage.setItem('access', data.access);
      localStorage.setItem('refresh', data.refresh);
      localStorage.setItem('type_user', data.type_user);
      localStorage.setItem('permissions', data.permissions);
      Cookie.set('access', data.access, { sameSite: 'strict' });
      Cookie.set('refresh', data.refresh, { sameSite: 'strict' });
      Cookie.set('type_user', data.type_user, { sameSite: 'strict' });
      Cookie.set('permissions', data.permissions, { sameSite: 'strict' });
      setIsLogged(true);
      dispatch(loginSuccess());
      dispatch(setIsWorker(true));
      dispatch(fetchUserInfo());
      await loadUserPermissions();
      navigate('/intranet/');
    } else if (status === 401) {
      setInvalidCredentials(true);
    } else {
      console.log('Error: ' + data.detail);
    }
    setLoading(false);
  };

  async function loadUserPermissions() {
    try {
      const permissions = await getUserPermissions();
      localStorage.setItem('user_permissions', JSON.stringify(permissions));
    } catch (error) {
      console.error('Error loading user permissions:', error);
    }
  }

  const handleIconType = passwordType === 'password' ?
    <IoEyeOutline className={`position-absolute end-0 translate-middle-y mx-3 cursor-pointer ${password !== '' && 'top-50'}`} color="#161a25" onClick={() => setPasswordType('text')} /> :
    <IoEyeOffOutline className={`position-absolute end-0 translate-middle-y mx-3 cursor-pointer ${password !== '' && 'top-50'}`} color="#161a25" onClick={() => setPasswordType('password')} />

  return (
    <Row className="backoffice-login-page d-flex flex-column">
      <HeadIntranet title={capitalize(t('iniciarSesion'))} />
      <Col xs={11} md={5} lg={3} xl={2}>
        <h1 className="title">INTRANET</h1>
        {invalidCredentials && (
          <p className="backoffice-login-credentials pb-2">
            {t('credencialesIncorrectas')}
          </p>
        )}
        <Form
          noValidate
          validated={validated}
          onSubmit={(e) => handleOnSubmit(e)}
        >
          <InputCustom
            className="mb-2 login-fields"
            type="text"
            value={emailInput}
            placeholder={t('correo')}
            onChange={(e) => handleName(e.target.value)}
            label={`${t('correo')} *`}
            required
            error={emailInput === '' && t('camporequerido', { ns: 'backoffice' })}
          />
          <InputCustom
            type={passwordType}
            value={password}
            placeholder={t('contrasena')}
            onChange={(e) => handlePassword(e.target.value)}
            label={`${t('contrasena')} *`}
            icon={handleIconType}
            className="px-0.75 login-fields"
            required
            error={password === '' && t('camporequerido', { ns: 'backoffice' })}
          />
          <ButtonCustom
            type={'submit'}
            color={'primary'}
            extraClass={'w-100 mt-3'}
            loading={loading}
          >
            {loading ?
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className='spinner'
              />
              : t('iniciarSesion')}
          </ButtonCustom>
        </Form>
      </Col>
    </Row>
  );
};

export default IntranetLogin;
